import { t } from 'i18next';
import { IGoalsTableData, IGoalsTableDataItems } from 'PDF/components/GoalsTable/types';
import { getMagazineTextObject } from 'PDF/helpers/pdfMapping';
import { ITimelineItem } from 'PDF/types/timeline';

import { IBusinessToolForm } from 'components/BusinessToolForm/utils/form';

import { getRiskGroupNameForExamplePage } from './helpers';

export const getMagazineItems = (businessPlanChapters: IBusinessToolForm) => {
  const { generalLaws, industryRequirements, legalRequirements } = businessPlanChapters.LEGAL_FRAMEWORKS_AND_RISKS;

  return [
    [getMagazineTextObject('', generalLaws)],
    [getMagazineTextObject('', industryRequirements)],
    [getMagazineTextObject('', legalRequirements)],
  ];
};

export const getListOfActions = (businessPlanChapters: IBusinessToolForm): ITimelineItem[] => {
  const { listOfActions } = businessPlanChapters.LEGAL_FRAMEWORKS_AND_RISKS;

  return listOfActions
    .map(({ startDate, expectedDeadline, stage }) => ({
      startDate,
      endDate: expectedDeadline,
      stage,
    }))
    .filter(({ startDate, endDate }) => startDate && endDate);
};

export const getListOfRisks = (businessPlanChapters: IBusinessToolForm, isExamplePage: boolean): IGoalsTableData => {
  const { listOfRisks } = businessPlanChapters.LEGAL_FRAMEWORKS_AND_RISKS;

  const otherGroupRisks = listOfRisks.filter((risk) => risk.group?.value === 'other' || risk.group === null);
  const restRisks = listOfRisks.filter((risk) => risk.group?.value !== 'other' && risk.group !== null);
  const risksList = [...restRisks, ...otherGroupRisks];

  const normalizedRisksList = risksList.map(({ name, group, negativeImpact, preventionMeasures }) => ({
    name: name || null,
    group: group || { label: '', value: null },
    negativeImpact: negativeImpact || null,
    preventionMeasures: preventionMeasures || null,
  }));

  const uniqueGroups = Array.from(new Set(normalizedRisksList.map((risk) => risk.group.value)));

  const groupedData = uniqueGroups.reduce<IGoalsTableDataItems>((res, groupName) => {
    const groupRisks = normalizedRisksList.filter((risk) => risk.group.value === groupName);

    if (!res[groupName]) {
      res[groupName] = {
        label: isExamplePage
          ? getRiskGroupNameForExamplePage(groupName)
          : t(`pdfPages.mappings.legalFrameworks.riskOptions.${groupName}`),
        content: [],
      };
    }

    groupRisks.forEach(({ name, negativeImpact, preventionMeasures }) => {
      res[groupName].content.push([name ?? '', negativeImpact ?? '', preventionMeasures ?? '']);
    });

    return res;
  }, {});

  return {
    header: [
      {
        label: isExamplePage ? 'Risk' : t('pdfPages.mappings.legalFrameworks.risk'),
        width: '94px',
        isBold: true,
      },
      {
        label: isExamplePage ? 'Negative impact' : t('pdfPages.mappings.legalFrameworks.negativeImpact'),
        width: '192px',
      },
      {
        label: isExamplePage ? 'Prevention measures' : t('pdfPages.mappings.legalFrameworks.prevMeasures'),
        width: '192px',
      },
    ],
    data: groupedData,
  };
};
